import React from 'react';
import { Link } from 'react-router-dom';

const PromoBanner = () => {
  const promos = [
    {
      id: 1,
      title: '%خصم 25',
      subtitle: 'على جميع منتجات الإلكترونيات',
      style: 'bg-[#1B1B1F] text-white',
      buttonStyle: 'bg-white text-[#1B1B1F] hover:bg-[#F2B705]',
      buttonText: 'تسوق الآن',
      link: '/category/electronics'
    },
    {
      id: 2,
      title: 'توصيل مجاني',
      subtitle: 'للطلبات أكثر من 200 ريال',
      style: 'bg-[#F2B705] text-[#1B1B1F]',
      buttonStyle: 'bg-[#1B1B1F] text-white hover:bg-white hover:text-[#1B1B1F]',
      buttonText: 'اطلب الآن',
      link: '/'
    },
    {
      id: 3,
      title: 'عروض الأزياء',
      subtitle: '%خصومات تصل إلى 50',
      style: 'bg-white text-[#1B1B1F] border-2 border-[#1B1B1F]',
      buttonStyle: 'bg-[#1B1B1F] text-white hover:bg-[#F2B705] hover:text-[#1B1B1F]',
      buttonText: 'اكتشف المزيد',
      link: '/category/mens-fashion'
    }
  ];
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {promos.map((promo, index) => (
            <div
              key={promo.id}
              className={`${promo.style} rounded-2xl p-8 text-center relative overflow-hidden
                shadow-[0_2px_10px_rgba(27,27,31,0.08)] transition-transform duration-300 hover:-translate-y-1
                ${index % 2 === 0 ? '-rotate-1' : 'rotate-1'} hover:rotate-0`}
            >
              {/* Background Pattern */}
              <div aria-hidden="true" className="absolute inset-0 opacity-[0.08]">
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-current rounded-full" />
                <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-current rounded-full" />
              </div>
              <div className="relative z-10">
                <h3
                  className="text-2xl font-extrabold mb-2"
                  style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
                >
                  {promo.title}
                </h3>
                <p className="text-base mb-6 opacity-80">
                  {promo.subtitle}
                </p>
                <Link
                  to={promo.link}
                  className={`inline-flex items-center justify-center whitespace-nowrap rounded-full
                    text-sm font-bold transition-colors px-5 py-2.5 ${promo.buttonStyle}
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2`}
                >
                  {promo.buttonText}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default PromoBanner;
